goog.provide('el8.service.infoField');
goog.provide('el8.service.infoFieldBig');

goog.require('el8.util.dom');
goog.require('el8.util.consts');

/**
 * This basically manages some shared code for highlighting inputs
 * as they're focused on and getting/setting values from them.
 * It's mostly used via the Form, which will instantiate an infoField
 * for every field it knows about.
 */
(function() {

    var BaseInfoField = function(spec) {

        var infoFieldClass = spec.infoFieldClass;
        var wrapClassSelector = spec.wrapClass;
        if (spec.wrapClasses) {
            wrapClassSelector = spec.wrapClasses.map(function(str) { return '.'+str; }).join(', ');
        }

        var activeWrapClass = spec.activeWrapClass;
        var infoClass = spec.infoClass;
        var activeInputClass = spec.activeInputClass;

        function noInput(field) {
            return Boolean(field.val() === null || field.val().trim() === '' ||
                field.val() === field.attr('_infotext') || field.val().length === 0);
        }

        // Function to add infoClass
        function applyInfoClass(field) {
            field.addClass(infoClass)
                .removeClass(activeInputClass);
            field.closest(wrapClassSelector).removeClass(activeWrapClass);
            if (el8.util.consts.SPELLCHECK) { field.attr('spellcheck', false); }
        }

        // Function to apply activeInputClass
        function applyActiveInputClass(field) {
            field.removeClass(infoClass)
                .addClass(activeInputClass);
            field.closest(wrapClassSelector).addClass(activeWrapClass);
            if (el8.util.consts.SPELLCHECK) { field.attr('spellcheck', true); }
        }

        function removeInfoClass(field) {
            field.removeClass(infoClass)
                .removeClass(activeInputClass);
            field.closest(wrapClassSelector).removeClass(activeWrapClass);
            if (el8.util.consts.SPELLCHECK) { field.attr('spellcheck', true); }
        }

        function applyBlueHighlight(field) {
            field.closest(wrapClassSelector).addClass('el8BlueHighlight');
            field.addClass('el8TransparentBackground');
        }

        function applyScribeHighlight(field) {
            field.closest(wrapClassSelector).addClass('el8ScribeHighlight');
            field.addClass('el8TransparentBackground');
        }

        function removeHighlight(field) {
            var element = field.closest(wrapClassSelector);
            element.removeClass('el8BlueHighlight');
            element.removeClass('el8ScribeHighlight');
            field.removeClass('el8TransparentBackground');
        }

        var THROTTLE_RATE = 400;
        var inputSelector = ':input.' + infoFieldClass;

        $(document).on('focus', inputSelector, function(e) {
            var field = $(this);
            if (noInput(field)) {
                field.val('');
            }
            if (!field.prop('disabled') && !field.closest('fieldset').prop('disabled')) {
                applyActiveInputClass(field);
            }
            return false;

        }).on('blur', inputSelector, function(e) {
            var field = $(this);
            var infoText = $(this).attr('_infotext') || '';
            if (noInput(field)) {
                field.val(infoText);
                applyInfoClass(field);
            } else {
                removeInfoClass(field);
            }
        }).on('select', inputSelector, function(e) {
            var field = $(this);
            if (noInput(field)) {
                e.preventDefault();
                return false;
            }
            return true;
        }).on('keydown', inputSelector, _.throttle(function(e) {
            var field = $(this);
            if (e.keyCode === KEYS.ESC) {
                field.trigger('blur');
            }
        }, THROTTLE_RATE)).on('paste', inputSelector, function(e) {
            var field = $(this);
            if (noInput(field)) {
                applyActiveInputClass(field);
            }
        });

        // Apply growing to all textareas
        var textAreaSelector = 'textarea.'+infoFieldClass;

        $(document).on('keyup change', textAreaSelector, _.throttle(function(e) {
            var $this = $(this);
            if ($this.attr('_nogrow')) { return; }
            var field = $this;
            var wrapper = $this.attr('_wrapper');
            var $wrapper = wrapper ? $this.closest(wrapper) : null;
            if ($this.attr('_doshrink')) {
                el8.util.dom.growShrinkTextarea(field, $wrapper, $this.attr('height'));
            } else {
                el8.util.dom.adjustTextareaHeight(field, $wrapper);
            }
        }, THROTTLE_RATE));

        var Widget = function(spec) {

            var isInit = false;
            var field = spec.field;
            var wrapper = spec.wrapper || null;
            var height = spec.height || null; // el8.util.consts.DEFAULT_FIELD_HEIGHT;
            var maxLength = spec.maxLength || null;
            var infoText = spec.infoText || '';
            var rows = spec.rows || null;
            var noGrow = (spec.noGrow === true); // defaults to false;
            var doShrink = (spec.doShrink === true); // defaults to false;
            var changeFn = spec.changeFn || null;
            // Don't know why change wasn't being handled on setVal before but we're
            // adding this flag to keep this new behavior opt-in rather than make it
            // the default, because there may be tons of form inputs at this point
            // that unintentionally depend on setVal not triggering change events.
            var handleChangeOnSetVal = Boolean(spec.handleChangeOnSetVal);
            var bootstrapFieldClass = 'ebs-form-control'; // bootstrap default form field class

            this.init = function() {
                if (!isInit) {
                    field.addClass(infoFieldClass + " " + bootstrapFieldClass);
                    field.attr('spellcheck', false);
                    field.attr('autocomplete', 'off');
                    if (doShrink) { field.attr('_doshrink', true); }
                    else if (noGrow) { field.attr('_nogrow', true); }
                    if (maxLength) { field.attr('maxlength', maxLength); }
                    if (height) {
                        field.attr('height', height);
                        field.css({'overflow': noGrow ? 'auto' : 'hidden'});
                        field.height(height);
                    } else {
                        field.removeAttr('height');
                    }
                    if (rows) { field.attr('rows', rows); }
                    if (wrapper) { field.attr('_wrapper', wrapper); }
                    isInit = true;
                }
                // Initialize with info text
                applyInfoClass(field);

                // Allow infoText to be either driven by the arg or by field attr
                if (infoText) {
                    field.attr('_infotext', infoText);
                } else {
                    infoText = field.attr('_infotext') || '';
                }
                field.val(infoText);

                // custom changeFn (used in ordermed)
                if (changeFn) { field.change(changeFn); }

            };
            this.init();

            this.getVal = function() {
                if (field.is(':file')) {
                    // If we have a file input, return the first file.
                    // If you want a multi-file input, the caller will have to custom manage that
                    if (field[0].files && field[0].files.length) {
                        return field[0].files[0];
                    }
                }
                return noInput(field) ? '' : field.val();
            };
            this.setVal = function(value, opts) {
                opts = opts || {};

                var isAutoSave = opts.isAutoSave;

                if (value !== null) {
                    value = cleanValue(value);
                    field.val(value);
                    if (changeFn && handleChangeOnSetVal) {
                        changeFn(value);
                    }
                    if (noInput(field)) {
                        this.init();
                    } else {
                        // if autosaving, user is and will still be focused in this field when the
                        // save is done, DO NOT remove the info classes in that case or we lose the
                        // focus styles on the input.
                        if (!isAutoSave) {
                            removeInfoClass(field);
                        }
                        if (!noGrow) {
                            el8.util.dom.adjustTextareaHeight(field);
                        }
                    }
                }
                return this;
            };
            this.getInputField = function() { return field; };
            this.setBlueHighlight = function() {
                var field = this.getInputField();
                applyBlueHighlight(field);
            };
            this.setScribeHighlight = function() {
                var field = this.getInputField();
                applyScribeHighlight(field);
            };
            this.removeAnyHighlight = function() {
                var field = this.getInputField();
                removeHighlight(field);
            };
            this.blur = function() { field.blur(); };
            this.getInfoText = function() { return infoText; };
            this.getMaxLength = function() { return maxLength; };
            // TODO This can be replaced with getVal()
            this.noInput = function() { return noInput(field); };

            /* JQuery .val() does not respect the maxlength attribute:
             * try to ensure we have a String if there's a maxlength and then
             * manually shorten the String; also handle Floats */
            function cleanValue(value) {
                if (!maxLength) { return value; }
                if (_.isArray(value) && value.length === 1) {
                    value = value[0];
                }
                if (_.isString(value)) {
                    value = value.substr(0, maxLength);
                }
                if (_.isNumber(value)) {
                    // notice "0.3" has length but only one significant digit,
                    // so this isn't a perfect filter
                    var maxFloatLen = Math.min(maxLength, 20); // avoid causing RangeError
                    value = parseFloat(value.toPrecision(maxFloatLen));
                }
                return value;
            }

        };

        return {
            addInfoField: function(opts) {
                return new Widget(opts);
            }
        };

    };

    el8.service.infoField = new BaseInfoField({
        wrapClasses: ['el8TextareaWrap', 'el8EditorTextareaWrap'],
        activeWrapClass: 'el8InFocus',
        infoFieldClass: 'info-field',
        infoClass: 'el8InfoText',
        activeInputClass: 'el8InFocusText'
    });

})();
